import { useCallback, useEffect, useState } from "react";
import ExtraPayService from "../../../../../../service/ExtraPayService";
import { EXTRAPAY_SUCCESS_CODE } from "../constants";

const readSession = () => ({
  token: localStorage.getItem("__extraconomy_token"),
  username: localStorage.getItem("__extraconomy_username"),
});

const initialState = {
  isLoading: true,
  hasError: false,
  conversionRate: 0,
  pointsBalance: 0,
  cycle: 0,
  ordersInCycle: 0,
  excBalance: 0,
};

const useExtrapayOverview = () => {
  const [state, setState] = useState(initialState);

  const reload = useCallback(async () => {
    const { token, username } = readSession();
    const service = new ExtraPayService(token);
    setState((current) => ({ ...current, isLoading: true, hasError: false }));

    try {
      const [card, points, cycle, orders, tokens] = await Promise.all([
        service.getCardByUser(username),
        service.getWalletPointsBalance(),
        service.getCycleCount(username),
        service.getOrdersInCycle(username),
        service.getWalletTokensBalance(),
      ]);
      const failed = [card, points, cycle, orders, tokens].find(
        (response) => response?.messageCode !== EXTRAPAY_SUCCESS_CODE,
      );

      if (failed) {
        setState((current) => ({ ...current, isLoading: false, hasError: true }));
        return { ok: false, code: failed.messageCode };
      }

      setState({
        isLoading: false,
        hasError: false,
        conversionRate: Number(card.result?.conversionRate) || 0,
        pointsBalance: Number(points.result?.balance) || 0,
        cycle: Number(cycle.result) || 0,
        ordersInCycle: Number(orders.result) || 0,
        excBalance: Number(tokens.result?.balance) || 0,
      });
      return { ok: true, excBalance: Number(tokens.result?.balance) || 0 };
    } catch (error) {
      setState((current) => ({ ...current, isLoading: false, hasError: true }));
      return { ok: false };
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { ...state, reload };
};

export default useExtrapayOverview;
